import { render, staticRenderFns } from "./Competition_table.vue?vue&type=template&id=369dc2e8&scoped=true"
import script from "./Competition_table.vue?vue&type=script&lang=js"
export * from "./Competition_table.vue?vue&type=script&lang=js"
import style0 from "./Competition_table.vue?vue&type=style&index=0&id=369dc2e8&prod&lang=css"
import style1 from "./Competition_table.vue?vue&type=style&index=1&id=369dc2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369dc2e8",
  null
  
)

export default component.exports